export default function RavielBrandSection() {
  return (
    <section className="mt-20 border-t border-gray-100 pt-16">
      {/* Brand Header */}
      <div className="text-center mb-14">
        <span className="inline-block text-[11px] font-bold tracking-[0.3em] uppercase px-4 py-1.5 rounded-full mb-4" style={{ backgroundColor: '#FFF0F0', color: '#C0504D' }}>
          Brand Story
        </span>
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight mb-2">RAVIEL</h2>
        <p className="text-lg text-gray-400 tracking-widest font-medium">라비엘 · 韩国美白护肤品牌</p>
        <p className="mt-4 text-[14px] text-gray-500 leading-relaxed max-w-2xl mx-auto">
          以天然维C精华为核心的韩国专业美白护肤品牌 · 아세로라 비타민C 기반 한국 전문 미백 스킨케어 브랜드
        </p>
      </div>

      {/* Hero Technology Block */}
      <div className="rounded-3xl overflow-hidden mb-12" style={{ background: 'linear-gradient(135deg, #1a0a0a 0%, #2d1010 50%, #1a0a0a 100%)' }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          <div className="p-10 lg:p-14 flex flex-col justify-center">
            <span className="inline-block text-[10px] font-bold tracking-[0.3em] uppercase px-3 py-1 rounded-full mb-6 w-fit" style={{ backgroundColor: 'rgba(255,100,80,0.15)', color: '#FF8070' }}>
              Core Ingredient
            </span>
            <h3 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4 tracking-tight">
              Acerola<br />
              <span className="text-2xl font-bold" style={{ color: '#FF9080' }}>Vitamin C Complex</span>
            </h3>
            <p className="text-[13px] leading-relaxed mb-2" style={{ color: '#A09080' }}>아세로라 비타민C 복합체 / 维C精华复合物</p>
            <p className="text-[14px] text-gray-300 leading-relaxed mt-4">
              天然维C含量是柠檬的65倍的超级果实——巴西樱桃（Acerola），与烟酰胺协同作用，从根本上解决暗斑问题。
            </p>
            <p className="text-[13px] leading-relaxed mt-2" style={{ color: '#7A6A5A' }}>
              레몬의 65배 비타민C를 함유한 슈퍼푸드 아세로라와 나이아신아마이드의 강력한 시너지로 기미·잡티를 근본적으로 케어합니다.
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              {[
                { zh: '抑制黑色素生成', ko: '멜라닌 생성 억제' },
                { zh: '提亮肤色', ko: '피부 톤 개선' },
                { zh: '抗氧化保护', ko: '항산화 보호' },
                { zh: '8次完售', ko: '8차 완판' },
              ].map((tag) => (
                <span key={tag.zh} className="text-[11px] px-3 py-1 rounded-full font-medium" style={{ backgroundColor: 'rgba(255,144,128,0.15)', color: '#FF9080', border: '1px solid rgba(255,144,128,0.2)' }}>
                  {tag.zh} <span style={{ opacity: 0.6 }}>/ {tag.ko}</span>
                </span>
              ))}
            </div>
          </div>
          <div className="p-10 lg:p-14 flex flex-col justify-center gap-5" style={{ borderLeft: '1px solid rgba(255,255,255,0.06)' }}>
            {[
              { num: '01', titleZh: '天然维C超级果实', titleKo: '천연 비타민C 슈퍼푸드', descZh: '巴西樱桃维C含量是柠檬的65倍，强力抗氧化，抑制黑色素生成', descKo: '아세로라의 비타민C 함량은 레몬의 65배, 강력한 항산화로 멜라닌 생성 억제' },
              { num: '02', titleZh: '烟酰胺协同增效', titleKo: '나이아신아마이드 시너지', descZh: '烟酰胺与维C精华双重作用，从黑色素生成到转移全程阻断', descKo: '나이아신아마이드와 아세로라의 이중 작용으로 멜라닌 생성부터 전달까지 전 과정 차단' },
              { num: '03', titleZh: '3日集中护理程序', titleKo: '3일 집중 케어 프로그램', descZh: '专为暗斑护理设计的3日集中护理程序，快速体验显著效果', descKo: '기미·잡티 케어를 위해 설계된 3일 집중 케어 프로그램으로 빠른 효과 경험' },
            ].map((item) => (
              <div key={item.num} className="flex gap-4">
                <span className="text-[11px] font-black shrink-0 mt-0.5" style={{ color: '#FF9080' }}>{item.num}</span>
                <div>
                  <p className="text-[13px] font-bold text-white mb-0.5">{item.titleZh}</p>
                  <p className="text-[11px] mb-1.5" style={{ color: '#7A6A5A' }}>{item.titleKo}</p>
                  <p className="text-[12px] leading-relaxed" style={{ color: '#8A7A6A' }}>{item.descZh}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Product Line Overview */}
      <div className="mb-12">
        <h3 className="text-center text-[11px] font-bold tracking-[0.25em] uppercase mb-8" style={{ color: '#8C7D6E' }}>
          Product Line · 제품 라인업
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            {
              icon: 'ri-drop-line',
              step: 'STEP 1',
              nameZh: '爽肤水 (Toner)',
              nameKo: '토너',
              volZh: '150ml',
              descZh: '第一步：深层渗透补水，整顿肤质，提升后续吸收力',
              descKo: '1단계: 깊은 침투 수분 공급, 피부결 정돈, 다음 단계 흡수력 향상',
              color: '#E8F4FF',
              accent: '#4A90D9',
            },
            {
              icon: 'ri-flask-line',
              step: 'STEP 2',
              nameZh: '安瓶 (Ampoule)',
              nameKo: '앰플',
              volZh: '30ml',
              descZh: '第二步：高浓度维C精华集中作用，快速淡化暗斑瑕疵',
              descKo: '2단계: 고농도 아세로라 집중 작용, 기미·잡티 빠른 케어',
              color: '#FFF0F0',
              accent: '#C0504D',
            },
            {
              icon: 'ri-heart-pulse-line',
              step: 'STEP 3',
              nameZh: '护理霜 (Cream)',
              nameKo: '크림',
              volZh: '50ml + 10ml',
              descZh: '第三步：锁住水分与营养，强化皮肤屏障，提亮肤色',
              descKo: '3단계: 수분·영양 잠금, 피부 장벽 강화, 피부 톤 개선',
              color: '#F0FFF4',
              accent: '#2E7D52',
            },
          ].map((item) => (
            <div key={item.step} className="rounded-2xl p-6" style={{ backgroundColor: item.color, border: `1px solid ${item.accent}20` }}>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-xl" style={{ backgroundColor: `${item.accent}20` }}>
                  <i className={`${item.icon} text-sm`} style={{ color: item.accent }}></i>
                </div>
                <span className="text-[10px] font-black tracking-widest" style={{ color: item.accent }}>{item.step}</span>
              </div>
              <p className="text-[14px] font-black text-gray-900 mb-0.5">{item.nameZh}</p>
              <p className="text-[11px] mb-1" style={{ color: '#8C7D6E' }}>{item.nameKo} · {item.volZh}</p>
              <p className="text-[12px] text-gray-600 leading-relaxed mt-2">{item.descZh}</p>
              <p className="text-[11px] mt-1 leading-relaxed" style={{ color: '#A09080' }}>{item.descKo}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Brand Values */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {[
          { icon: 'ri-leaf-line', titleZh: '天然成分', titleKo: '천연 성분', descZh: '以天然巴西樱桃维C为核心的纯净成分', descKo: '천연 아세로라 비타민C를 핵심으로 한 순한 성분' },
          { icon: 'ri-award-line', titleZh: '8次完售', titleKo: '8차 완판', descZh: '连续8次完售的超人气美白护肤品', descKo: '연속 8차 완판을 기록한 초인기 미백 스킨케어' },
          { icon: 'ri-shield-check-line', titleZh: '皮肤科测试', titleKo: '피부과 테스트', descZh: '皮肤科专家测试完成，安全性经过验证', descKo: '피부과 전문의 테스트 완료, 안전성 검증' },
          { icon: 'ri-global-line', titleZh: '韩国制造', titleKo: '한국산', descZh: '韩国原产，严格品质管理', descKo: '한국산 원산지, 엄격한 품질 관리' },
        ].map((item) => (
          <div key={item.titleZh} className="rounded-2xl p-6 text-center" style={{ backgroundColor: '#FAFAF8', border: '1px solid #EDE8E0' }}>
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl mx-auto mb-4" style={{ backgroundColor: '#FFF0F0' }}>
              <i className={`${item.icon} text-xl`} style={{ color: '#C0504D' }}></i>
            </div>
            <p className="text-[13px] font-bold text-gray-800 mb-0.5">{item.titleZh}</p>
            <p className="text-[11px] mb-2" style={{ color: '#8C7D6E' }}>{item.titleKo}</p>
            <p className="text-[12px] text-gray-500 leading-relaxed">{item.descZh}</p>
          </div>
        ))}
      </div>

      {/* How to Use */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
        <div className="rounded-2xl p-8" style={{ backgroundColor: '#F7F4F0', border: '1px solid #EDE8E0' }}>
          <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5" style={{ color: '#8C7D6E' }}>How to Use · 사용 방법</h4>
          <div className="space-y-4">
            {[
              { step: '01', zh: '洁面后，取适量爽肤水轻拍至全脸吸收', ko: '세안 후 토너를 적당량 덜어 얼굴 전체에 가볍게 두드려 흡수' },
              { step: '02', zh: '取1~2滴安瓶，重点涂抹于暗斑瑕疵处', ko: '앰플 1~2방울을 기미·잡티 부위에 집중적으로 도포' },
              { step: '03', zh: '最后取适量护理霜，均匀涂抹全脸锁住精华', ko: '마지막으로 크림을 적당량 덜어 얼굴 전체에 고르게 발라 마무리' },
            ].map((item) => (
              <div key={item.step} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full shrink-0 mt-0.5 text-[10px] font-black" style={{ backgroundColor: '#C0504D', color: '#fff' }}>
                  {item.step}
                </div>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px] mt-0.5" style={{ color: '#8C7D6E' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl p-8" style={{ backgroundColor: '#F7F4F0', border: '1px solid #EDE8E0' }}>
          <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5" style={{ color: '#8C7D6E' }}>Target · 적합 대상</h4>
          <div className="space-y-3">
            {[
              { zh: '有黑斑、色斑、暗沉困扰的人群', ko: '기미·잡티·칙칙한 피부 톤으로 고민하는 분' },
              { zh: '想要提亮肤色、改善肤质的人群', ko: '피부 톤 개선과 피부결 정돈을 원하는 분' },
              { zh: '寻找高效美白护肤品的人群', ko: '효과적인 미백 스킨케어를 찾는 분' },
              { zh: '追求天然成分护肤的人群', ko: '천연 성분 스킨케어를 추구하는 분' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full shrink-0 mt-0.5" style={{ backgroundColor: '#C0504D' }}>
                  <i className="ri-check-line text-white text-[10px]"></i>
                </div>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px]" style={{ color: '#8C7D6E' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Awards */}
      <div className="rounded-2xl p-8" style={{ backgroundColor: '#1a0a0a' }}>
        <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-6 text-center" style={{ color: '#8C7D6E' }}>Brand Highlights · 브랜드 하이라이트</h4>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { icon: 'ri-fire-line', titleZh: '8次完售记录', titleKo: '8차 완판 기록', year: '완판' },
            { icon: 'ri-leaf-line', titleZh: '天然维C成分', titleKo: '천연 비타민C', year: '핵심' },
            { icon: 'ri-shield-check-line', titleZh: '皮肤科安全认证', titleKo: '피부과 안전 인증', year: '인증' },
            { icon: 'ri-star-line', titleZh: '消费者好评第一', titleKo: '소비자 호평 1위', year: '2024' },
          ].map((item) => (
            <div key={item.titleZh} className="text-center p-4 rounded-xl" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3" style={{ backgroundColor: 'rgba(255,144,128,0.15)' }}>
                <i className={`${item.icon} text-lg`} style={{ color: '#FF9080' }}></i>
              </div>
              <p className="text-[12px] font-bold text-white mb-0.5">{item.titleZh}</p>
              <p className="text-[10px] mb-1" style={{ color: '#5A4A3A' }}>{item.titleKo}</p>
              <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(255,144,128,0.1)', color: '#FF9080' }}>{item.year}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
